import Api from "@/services/DHL/Api";

export default {
  track(id) {
    return Api().get(`shipments?trackingNumber=${id}&requesterCountryCode=DE&originCountryCode=DE&language=de`);
  },

};
